import { PENDING_AUTH_METHOD_KEY } from './pending-auth-method-key';

export function setPendingAuthMethod(method: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  try {
    window.sessionStorage.setItem(PENDING_AUTH_METHOD_KEY, method);
  } catch {}
}
